export enum TeleprompterSettingsInteractions {
  REMOVED = 'Removed',
  ADDED = 'Added',
  CHANGED = 'Changed',
  SET_AS_DEFAULT = 'Set as Default',
  VIEWED = 'Viewed',
  DUPLICATE = 'Duplicate',
  USED = 'Used',
  SHARED = 'Shared',
  SAVED_SETTINGS = 'Saved Settings',
}
